import * as CarModels from '../../models/car/car';
import { CarSearchModel, CarUpdateModel } from '../../models/car/carSearch';
import * as Models from '../../models/commonModels';


export class GetCarTypeDictionary {
  static readonly type = '[Car ] GetCarTypeDictionary';
  constructor() { }
}

export class Get {
  static readonly type = '[Car] Get';
  constructor(public CarId: number) { }
}

export class Set {
  static readonly type = '[Car] Set';
  constructor(public Car: CarModels.CarModel) { }
}

export class GetList {
  static readonly type = '[Car] List';
  constructor(public Search: CarSearchModel) { }
}

export class GetDictionary {
  static readonly type = '[Car] Get Dictionary';
  constructor(public Search: CarSearchModel) { }
}

export class SetSearch {
  static readonly type = '[Car] Set Search';
  constructor(public Search: CarSearchModel) { }
}

export class ResetSearch {
  static readonly type = '[Car] Reset Search';
  constructor() { }
}

export class DisposeSearch {
  static readonly type = '[Car] Dispose Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[Car] Set List Page';
  constructor(public Search: CarSearchModel) { }
}

export class Insert {
  static readonly type = '[Car] Insert';
  constructor(public Car: Models.Request<CarModels.CarModel>) { }
}

export class ResetSave {
  static readonly type = '[Car] ResetSave';
  constructor() { }
}

export class SetMarkList {
  static readonly type = '[Car] SetMarkList';
  constructor(public RegistrationNumbers: string[]) { }
}

export class BlockMarked {
  static readonly type = '[Car] BlockMarked';
  constructor(public CarsUpdate: CarUpdateModel, public ReloadAfterSuccessUpdate?: boolean) { }
}

export class Delete {
  static readonly type = '[Car] Delete';
  constructor(public Car: Models.Request<CarModels.CarModel>) { }
}

export class UnblockMarked {
  static readonly type = '[Car] UnblockMarked';
  constructor(public CarsUpdate: CarUpdateModel, public ReloadAfterSuccessUpdate?: boolean) { }
}

export class ChangeRegistrations {
  static readonly type = '[Car] ChangeRegistrations';
  constructor(public formData: FormData) { }
}

export class ImportData {
  static readonly type = '[Car] ImportData';
  constructor(public formData: FormData) { }
}

export class ImportCars {
  static readonly type = '[Car] Import Cars';
  constructor(public ReportName: string, public FileName: string, public Data: any) { }
}

export class ChangeCustomer {
  static readonly type = '[Car] ChangeCustomer';
  constructor(public CarsUpdate: CarUpdateModel) { }
}

export class GetFilteredReport {
  static readonly type = '[Car] GetFilteredReport';
  constructor(public ReportName: string, public Search: CarSearchModel) { }
}

export class GetMarkedReport {
  static readonly type = '[Car] GetMarkedReport';
  constructor(public ReportName: string,public Marked: CarUpdateModel) { }
}

export class ShowImportPanel {
  static readonly type = '[Car] ShowImportPanel';
  constructor(public show: boolean) { }
}

export class CheckNumbers {
  static readonly type = '[Car] CheckNumbers';
  constructor(public Numbers: string[]) { }
}

export class ClearErrorList {
  static readonly type = '[Car] ClearErrorList';
  constructor() { }
} 

export class GetCarTyreDetail {
  static readonly type = '[Car] Get Car Tyre Detail';
  constructor(public CarId: number) { }
}

export class SendSMSMessage {
  static readonly type = '[Car] Send SMS Message';
  constructor(public Message: CarModels.CarSendMessage) { }
}

export class SendEmailMessage {
  static readonly type = '[Car] Send Email Message';
  constructor(public Message: CarModels.CarSendMessage) { }
}

export class GeSearchBarList {
  static readonly type = '[Car] Search bar List';
  constructor(public Search: CarSearchModel) { }
}

export class Create {
  static readonly type = '[Car] Create';
  constructor(public Car: Models.Request<CarModels.CarModel>) { }
}

export class Merge {
  static readonly type = '[Car] Merge';
  constructor(public Cars: Models.ContextRequest<CarModels.CarModel, CarModels.CarModel>) { }
}

export class SendSMSMessageFiltered {
  static readonly type = '[Car] SMS Filtered';
  constructor(public SMS: Models.ContextRequest<CarSearchModel, CarModels.CarSendMessage>) { }
}

export class SendSMSMessageMarked {
  static readonly type = '[Car] SMS Marked';
  constructor(public SMS: Models.ContextRequest<CarUpdateModel, CarModels.CarSendMessage>) { }
}

export class GetCarNotes {
  static readonly type = '[Car] Get Car Notes';
  constructor(public CarId: Models.RequestModel) { }
}

export class SetCarNote {
  static readonly type = '[Car] Set Car Note';
  constructor(public Note: Models.Request<CarModels.CarNoteModel>) { }
}

export class ImportReRegistration {
  static readonly type = '[Car] ImportReRegistration';
  constructor(public ImportFile: File) { }
}
